const POSITION_LABEL_MATCHERS = {
  GK: ["gk", "goalkeeper", "keeper"],
  DEF: ["def", "defender", "centreback", "centerback", "fullback", "back"],
  MID: ["mid", "midfielder", "midfield"],
  FWD: ["fwd", "forward", "attacker", "striker", "winger"],
};

const CODE_PATTERN = /^[A-Z0-9]{2,6}$/;

const normalizeValue = (value = "") =>
  String(value)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const normalizeTrustedCode = (value = "") => {
  const normalized = String(value).trim().toUpperCase();
  if (!normalized) {
    return "";
  }
  return CODE_PATTERN.test(normalized) ? normalized : "";
};

const getPositionSource = (position) => {
  if (Array.isArray(position)) {
    return position[0] || null;
  }
  return position;
};

const abbreviationFromLabel = (label = "") => {
  const normalizedLabel = normalizeValue(label);
  if (!normalizedLabel) {
    return "";
  }

  const matchedEntry = Object.entries(POSITION_LABEL_MATCHERS).find(([, matchers]) =>
    matchers.some((matcher) => normalizedLabel.includes(matcher))
  );

  if (matchedEntry) {
    return matchedEntry[0];
  }

  const words = normalizedLabel.split(" ").filter(Boolean);
  if (words.length === 1) {
    return words[0].slice(0, 3).toUpperCase();
  }

  return words
    .slice(0, 3)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
};

export const getPositionAbbreviation = (position) => {
  const source = getPositionSource(position);
  if (!source) {
    return "-";
  }

  if (typeof source === "string") {
    const trustedCode = normalizeTrustedCode(source);
    return trustedCode || abbreviationFromLabel(source) || "-";
  }

  const trustedCode =
    normalizeTrustedCode(source?.short_name) ||
    normalizeTrustedCode(source?.shortName) ||
    normalizeTrustedCode(source?.code);

  if (trustedCode) {
    return trustedCode;
  }

  const label =
    source?.name ||
    source?.lexic_id ||
    source?.position ||
    source?.title ||
    "";

  return abbreviationFromLabel(label) || "-";
};

export default getPositionAbbreviation;
